import React, { ComponentProps } from 'react';

import Dropdown, { Menu, MenuItem } from '@adsk/alloy-react-dropdown';
import FormField from '@adsk/alloy-react-form-field';

import { FilterOption } from '../../types';

type RenderMenuType = ComponentProps<typeof Dropdown>['renderMenu'];

interface FilterProps {
  label: React.ReactNode;
  options: FilterOption[];
  placeholder?: string;
  value?: unknown[];
  onChange?: (value: unknown[]) => void;
  renderOption?: (option: unknown) => JSX.Element;
  isLoading?: boolean;
}

const Filter: React.FC<React.PropsWithChildren<FilterProps>> = ({
  label,
  options,
  placeholder,
  value,
  onChange,
  renderOption,
  isLoading,
}) => {
  const selectedOptions =
    value &&
    options.filter((option) => value.some((val) => option.value === val));

  const renderMenu: RenderMenuType = (args) => {
    const { menuItems, getItemProps } = args;
    return (
      <Menu {...args}>
        {menuItems?.map((item, index) => {
          const itemProps = getItemProps({
            item,
          });
          const renderOptionProps = renderOption
            ? { subText: null, text: renderOption(item) }
            : {};
          return <MenuItem key={index} {...itemProps} {...renderOptionProps} />;
        })}
      </Menu>
    );
  };

  return (
    <FormField
      style={{ marginBottom: 20 }}
      label={label}
      labelVariant={FormField.LABEL_VARIANTS.TOP}
    >
      <Dropdown
        style={{ width: '100%' }}
        isAutocomplete
        isMultiple
        items={options}
        selectedItems={selectedOptions}
        onSelectedItemsChange={(changes) => {
          onChange?.(changes?.selectedItems || []);
        }}
        isLoading={isLoading}
        placeholder={placeholder}
        renderMenu={renderMenu}
      />
    </FormField>
  );
};

Filter.displayName = 'SubmittalsFilter';
Filter.defaultProps = {
  value: [],
  isLoading: false,
};

export default Filter;
